<template>
  <vx-card id="print-report" class="w-full">
    <!-- 주요의견 및 조치사항 -->
    <h5><i class="dot"></i>주요의견 및 조치사항</h5>

    <vs-tabs>
      <vs-tab v-for="tab of ['산업안전보건위원회', '안전보건협의체', '설비안전위원회', '크레인안전협의체']" :key="`tab-${tab}`" :label="tab" @click="onClickTab(tab)" />
    </vs-tabs>

    <div class="flex flex-wrap items-center mb-3 gap-2">
      <div class="flex items-center justify-center gap-3">
        <vs-select v-model="selectedYear" autocomplete @change="loadPost"> <vs-select-item v-for="year in years" :key="`year-${year}`" :value="year" :text="year" /></vs-select>
        <vs-select v-if="currentTab === '산업안전보건위원회'" v-model="selectedMonth" autocomplete @change="loadPost" style="width: 80px">
          <vs-select-item v-for="month in 4" :key="`quater-${month}`" :value="month" :text="`${month}분기`" />
        </vs-select>
        <vs-select v-else-if="currentTab === '안전보건협의체' || currentTab === '설비안전위원회'" v-model="selectedMonth" autocomplete @change="loadPost" style="width: 80px">
          <vs-select-item v-for="month in 12" :key="`month-${month}`" :value="month" :text="`${month}월`" />
        </vs-select>
        <vs-select v-else-if="currentTab === '크레인안전협의체'" v-model="selectedMonth" autocomplete @change="loadPost" style="width: 120px">
          <vs-select-item :value="1" text="1월~2월" />
          <vs-select-item :value="3" text="3월~4월" />
          <vs-select-item :value="5" text="5월~6월" />
          <vs-select-item :value="7" text="7월~8월" />
          <vs-select-item :value="9" text="9월~10월" />
          <vs-select-item :value="11" text="11월~12월" />
        </vs-select>
      </div>
      <div v-if="0 < Object.keys(list).length" class="w-full sm:w-auto ml-0 sm:ml-auto flex gap-2">
        <vs-button v-if="!isEditMode" class="w-full flex-1 " color="secondary" type="border" @click="onClickEnterResults"> 조치 결과 입력 </vs-button>
        <div v-else class="w-full flex gap-2">
          <vs-button class="w-full flex-1 " color="secondary" type="border" @click="onClickEnterResultsCencel"> 취소 </vs-button>
          <vs-button class="w-full flex-1 " color="secondary" @click="onClickEnterResultsSave"> 저장 </vs-button>
        </div>
      </div>
    </div>

    <div class="w-full overflow-x-auto">
      <table>
        <colgroup>
          <col width="200" />
          <col width="400" />
          <col width="400" />
          <col width="400" />
        </colgroup>
        <thead>
        <tr>
          <th rowspan="2">구분</th>
          <th v-if="currentTab === '산업안전보건위원회'" colspan="3">산업안전보건위원회(1회/분기)</th>
          <th v-else-if="currentTab === '안전보건협의체'" colspan="3">안전보건협의체(1회/월)</th>
          <th v-else-if="currentTab === '설비안전위원회'" colspan="3">설비안전위원회(1회/월)</th>
          <th v-else-if="currentTab === '크레인안전협의체'" colspan="3">크레인안전협의체(1회/2개월)</th>
        </tr>
        <tr>
          <th>주요 의견</th>
          <th>조치 계획</th>
          <th>조치 결과</th>
        </tr>
        </thead>
        <tbody>
        <fragment v-for="(item, key, index) in list" :key="index">
          <tr v-for="(row, row_i) in item.rows" :key="`${index}_row_${row_i}`" @click="() => onClickRow(row.postId)" :class="isEditMode ? 'editMode' : ''">
            <td v-if="row_i === 0" :rowspan="item.rows.length" class="bg-th">{{ item.label }}</td>
            <td class="whitespace-pre-wrap text-left">{{ row.주요의견 }}</td>
            <td class="whitespace-pre-wrap text-left">{{ row.조치계획 }}</td>
            <td v-if="!isEditMode" class="whitespace-pre-wrap text-left">{{ row.조치결과 }}</td>
            <td v-else style="padding: 10px" class="text-left"><MaxLengthTextarea rows="4" v-model="row.edit조치결과" class="w-full mb-0" /></td>
          </tr>
        </fragment>
        <tr v-if="0 === Object.keys(list).length">
          <td colspan="4">표시할 데이터가 없습니다.</td>
        </tr>
        </tbody>
      </table>
    </div>
  </vx-card>
</template>

<script>
import MaxLengthTextarea from "@/components/MaxLengthTextarea.vue";
import DateUtil from "@/util/DateUtil.js";

export default {
  components: { MaxLengthTextarea },
  data() {
    return {
      isEditMode: false,
      currentTab: "산업안전보건위원회",
      selectedYear: new Date().getFullYear(),
      years: [],
      selectedMonth: 1,

      list: {},
    };
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    tabBoardId() {
      switch (this.currentTab) {
        case "산업안전보건위원회":
          return 818;
        case "안전보건협의체":
          return 819;
        case "설비안전위원회":
          return 820;
        case "크레인안전협의체":
          return 821;
      }
    },
  },
  created() {
    this.generateYears();
    this.loadPost();
  },
  methods: {
    generateYears() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 50;
      for (let year = currentYear; year >= startYear; year--) {
        this.years.push(year);
      }
    },
    onClickTab(tab) {
      // 날짜 변환
      const oldMonth = this.selectedMonth;
      this.selectedMonth = this.updateSelectedMonth(tab, this.currentTab);

      this.currentTab = tab;
      if (oldMonth === this.selectedMonth) this.loadPost();
    },
    onClickEnterResults() {
      this.isEditMode = true;
    },
    onClickEnterResultsCencel() {
      this.isEditMode = false;
      const list = JSON.parse(JSON.stringify(this.list));
      for (const key in list) {
        list[key].rows = list[key].rows.map((row) => {
          return { ...row, edit조치결과: row.조치결과 };
        });
      }
      this.list = list;
    },
    async onClickEnterResultsSave() {
      const list = JSON.parse(JSON.stringify(this.list));

      const tempFieldLable = [];
      const promises = [];

      for (const key in list) {
        list[key].rows = list[key].rows.map((row) => {
          tempFieldLable.push(`${list[key].label}(${key})`);

          const content = JSON.parse(row.originData.post_content);
          content.body.subInfo.조치결과 = row.edit조치결과;

          const promise = this.$store.dispatch("board/UPDATE_POST", {
            projectId: row.originData.project_id,
            boardId: row.originData.board_id,
            postId: row.originData.id,
            title: row.originData.post_title,
            content: JSON.stringify(content),
          });

          promises.push(promise);

          return { ...row, 조치결과: row.edit조치결과 };
        });
      }

      const results = await Promise.allSettled(promises);

      const fulfilledLabels = [];
      const rejectedLabels = [];
      results.map((result, index) => {
        if (result.status === "fulfilled") fulfilledLabels.push(tempFieldLable[index]);
        else if (result.status === "rejected") rejectedLabels.push(tempFieldLable[index]);
      });

      const fulfilledStr = [...new Set(fulfilledLabels)].join(", ");
      const rejectedStr = [...new Set(rejectedLabels)].join(", ");

      if (0 < rejectedStr.length) this.customAlert(`${rejectedStr}의 조치 결과 저장에 실패하였습니다.`, "저장");
      else {
        this.customAlert(`${fulfilledStr}의 조치 결과를 저장하였습니다.`, "저장");
        this.list = list;
        this.isEditMode = false;
      }
    },
    onClickRow(postId) {
      if (this.isEditMode) return;
      this.$router.push({
        name: this.routeU,
        params: {
          proj_id: this.projectId,
          boardId: this.tabBoardId,
          boardSlug: `board-${this.tabBoardId}`,
          postId,
          pageType: "write",
        },
      });
    },
    updateSelectedMonth(newTab, oldTab) {
      // oldTab에 따른 selectedMonth 변환
      let newSelectedMonth = this.selectedMonth;

      if (oldTab === "크레인안전협의체") {
        // 크레인안전협의체에서 다른 탭으로 이동
        if (newSelectedMonth === 1) {
          newSelectedMonth = 1; // 1월~2월 => 1분기 또는 1월
        } else if (newSelectedMonth === 3) {
          newSelectedMonth = 3; // 3월~4월 => 2분기 또는 3월
        } else if (newSelectedMonth === 5) {
          newSelectedMonth = 5; // 5월~6월 => 3분기 또는 5월
        } else if (newSelectedMonth === 7) {
          newSelectedMonth = 7; // 7월~8월 => 4분기 또는 7월
        } else if (newSelectedMonth === 9) {
          newSelectedMonth = 9; // 9월~10월 => 9월
        } else if (newSelectedMonth === 11) {
          newSelectedMonth = 11; // 11월~12월 => 11월
        }
      } else if (oldTab === "산업안전보건위원회") {
        // 산업안전보건위원회에서 다른 탭으로 이동 (1~4분기)
        if (newSelectedMonth === 1) {
          newSelectedMonth = 1; // 1분기 => 1월~3월
        } else if (newSelectedMonth === 2) {
          newSelectedMonth = 4; // 2분기 => 4월~6월
        } else if (newSelectedMonth === 3) {
          newSelectedMonth = 7; // 3분기 => 7월~9월
        } else if (newSelectedMonth === 4) {
          newSelectedMonth = 10; // 4분기 => 10월~12월
        }
      }

      // newTab에 따른 selectedMonth 변환
      if (newTab === "크레인안전협의체") {
        if (newSelectedMonth >= 1 && newSelectedMonth <= 2) {
          return 1; // 1분기 또는 1~2월 => 1월~2월
        } else if (newSelectedMonth >= 3 && newSelectedMonth <= 4) {
          return 3; // 2분기 또는 3~4월 => 3월~4월
        } else if (newSelectedMonth >= 5 && newSelectedMonth <= 6) {
          return 5; // 3분기 또는 5~6월 => 5월~6월
        } else if (newSelectedMonth >= 7 && newSelectedMonth <= 8) {
          return 7; // 4분기 또는 7~8월 => 7월~8월
        } else if (newSelectedMonth >= 9 && newSelectedMonth <= 10) {
          return 9; // 9월~10월 유지
        } else if (newSelectedMonth >= 11 && newSelectedMonth <= 12) {
          return 11; // 11월~12월 유지
        }
      } else if (newTab === "산업안전보건위원회") {
        if (newSelectedMonth <= 3) {
          return 1; // 1월~3월 => 1분기
        } else if (newSelectedMonth <= 6) {
          return 2; // 4월~6월 => 2분기
        } else if (newSelectedMonth <= 9) {
          return 3; // 7월~9월 => 3분기
        } else if (newSelectedMonth <= 12) {
          return 4; // 10월~12월 => 4분기
        }
      } else if (newTab === "안전보건협의체" || newTab === "설비안전위원회") {
        return newSelectedMonth; // 그대로 유지
      }
    },
    // 게시물 불러오기 (818,819,820,821)
    async loadPost() {
      if (!this.selectedYear) return;

      this.isEditMode = false;

      const projectId = this.$route.params.proj_id;
      const page = 1;
      const perPage = 10000;
      const dateTarget = this.tabBoardId === 818 ? "body.subInfo.회의일자" : "body.monthDate";

      let date;
      let dateSE;

      if (this.tabBoardId === 818) {
        if (this.selectedMonth === 1) date = `${this.selectedYear}-01-01`;
        else if (this.selectedMonth === 2) date = `${this.selectedYear}-04-01`;
        else if (this.selectedMonth === 3) date = `${this.selectedYear}-07-01`;
        else date = `${this.selectedYear}-10-01`;

        dateSE = DateUtil.getQuarterDates(date);
      } else if (this.tabBoardId === 821) {
        date = `${this.selectedYear}-${this.selectedMonth}-01`;
        dateSE = DateUtil.getTwoMonthPeriod(date);
      } else {
        date = `${this.selectedYear}-${this.selectedMonth}-01`;
        dateSE = DateUtil.getMonthDates(date);
      }

      const conditions = [];
      conditions.push({ key: dateTarget, operator: ">=", value: dateSE.start });
      conditions.push({ key: dateTarget, operator: "<=", value: dateSE.end });

      await this.$store.dispatch("board/LOAD_POST_LIST", { projectId, boardId: this.tabBoardId, page, perPage, conditions });
      const list = this.$store.state.board.postListInfo.data;

      const _datas = {};

      if (0 < list.length) {
        list.map((data) => {
          const filedId = data.field_id;
          const content = JSON.parse(data.post_content);
          if (!_datas[filedId]) {
            _datas[filedId] = {
              label: data.field.field_name,
              rows: [],
            };
          }

          _datas[filedId].rows.push({
            postId: data.id,
            주요의견: content.body.subInfo.종사자의견,
            조치계획: content.body.subInfo.조치계획,
            조치결과: content.body.subInfo.조치결과,
            edit조치결과: content.body.subInfo.조치결과,
            originData: data,
          });
        });
      }

      this.list = JSON.parse(JSON.stringify(_datas));
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: calc(100% - 1px);
  table-layout: fixed;
  border-collapse: collapse;
  background: #fafafa;

  tbody {
    tr {
      cursor: pointer;

      &.editMode {
        cursor: default;
      }
    }
  }

  &,
  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    padding: 14px;

    border: 1px solid #cdcdcd;
  }

  td.text-left {
    text-align: left;
  }

  .editMode {
    padding: 7px;
  }

  th,
  .bg-th {
    background: #fafafa;
  }

  td {
    font-weight: 400;
    background: white;
  }
}

.circle {
  width: 10px;
  height: 10px;
  background: #28c76f;
  border-radius: 100%;
}
</style>
